import {match} from 'ts-pattern';
import type {ZodIssue} from 'zod';

import type {CheckoutProfileMockRefusal} from './checkoutProfileMockRefusal';

export function getCheckoutProfileMockShapeRefusals(
  issues: ZodIssue[],
  nameCode: 'PROFILE_NAME_REQUIRED' | 'RULE_NAME_REQUIRED'
): CheckoutProfileMockRefusal[] {
  return issues.map((issue) => ({
    code:
      issue.code === 'custom'
        ? issue.message
        : match(issue.path.at(-1))
            .with('name', () => nameCode)
            .with('priority', () => 'PRIORITY_INVALID')
            .otherwise(() => 'VALUE_NOT_ALLOWED'),
    path: (issue.path[0] === 'body' ? issue.path.slice(1) : issue.path).join('.'),
    message: issue.message,
  }));
}
